export const chartPointType = [0, 1, 2]

export const chartSessionPointsFields = ['correct', 'error', 'prompt']
